// extracted by css-extract-rspack-plugin
export default {"root":"_vkXMa","input-wrapper":"_jnSJe","inputWrapper":"_jnSJe","price-button":"mCrFvw","priceButton":"mCrFvw"};